import script from "./ViewingCardHomeDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewingCardHomeDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ViewingCardHomeDetails.vue?vue&type=style&index=0&id=331dca33&lang=postcss&scoped=true"

import exportComponent from "/var/www/keyvue-customer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331dca33"]])

export default __exports__